import { getConfigWithDefaults } from '@ow/utils'

const defaultConfig = {
  subdistrict: 0, // 显示下级行政区级数
  extensions: 'all', // 是否返回行政区边界坐标点
  level: 'city', // country：国家 province：省/直辖市 city：市 district：区/县 biz_area
  showbiz: false, // 是否显示商圈
}

const District = (customConfig) => {
  const opts = getConfigWithDefaults(defaultConfig, customConfig)

  const setLevel = (layer) => (level) => {
    layer.district.setLevel(level)
  }

  const clear = (AMap, amap, layer) => () => {
    amap.remove(layer.polygons)
  }

  const render =
    (AMap, amap, layer) =>
    (
      name,
      style = {
        strokeWeight: 1,
        fillOpacity: 0.4,
        fillColor: '#80d8ff',
        strokeColor: '#0091ea',
      }
    ) => {
      layer.district.search(name, function (status, result) {
        const bounds = result.districtList[0].boundaries
        if (bounds) {
          const mask = []
          for (let i = 0; i < bounds.length; i++) {
            mask.push([bounds[i]])
          }
          amap.setMask(mask)
          // for (let i = 0; i < bounds.length; i++) {
          //   const polyline = new AMap.Polyline({
          //     path: bounds[i],
          //     ...style,
          //   })
          //   amap.add(polyline)
          // }

          amap.setFitView()
        }
      })
    }

  const setApis = (AMap, amap) => ({
    initDistrict: (layer) => {
      layer.polygons = []
      layer.district = new AMap.DistrictSearch(opts)
      layer.setLevel = setLevel(layer)
      layer.clear = clear(AMap, amap, layer)
      layer.render = render(AMap, amap, layer)
    },
  })

  return {
    amapPlugins: ['AMap.DistrictSearch'],
    setApis,
  }
}

export default District
